import Tag from '@rio-cloud/rio-uikit/Tag';
import { FormattedMessage } from 'react-intl';

import type { NoServiceFeeAlertProps } from '@/components/NoServiceFeeAlert/types';

export const NoServiceFeeAlert = ({ messageId }: NoServiceFeeAlertProps) => (
    <div className='alert alert-success margin-y-15'>
        <div className='display-flex gap-10 align-items-start'>
            <Tag className='bg-success text-color-white display-flex' round={false} size='small'>
                <FormattedMessage id='alert.NoServiceFee.tag' />
            </Tag>
            <p className='margin-y-0'>
                <FormattedMessage id={messageId} />
            </p>
        </div>
    </div>
);
